import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectUnknownRoleGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // If user has a known role (USER, ADMIN, or root), allow access
    if (this.whoami.isUser() || this.whoami.isAdmin() || this.whoami.isRoot()) {
      return of(true);
    }

    // If user is authenticated but has no known role, redirect to profile
    if (this.whoami.isAuthenticated()) {
      this.router.navigate(['/me']);
      return of(false);
    }

    // If not authenticated, allow other guards to handle
    return of(true);
  }
}
